 
import Carousel from "./Carousel";
import Service from "./Service";

  
function Home() {
  return <div>
   {/* <Carousel></Carousel> */}
      <Service></Service> 
      
  </div>;
}
export default Home;
